import { render, staticRenderFns } from "./UsersRequests.vue?vue&type=template&id=6bde5704&scoped=true&"
import script from "./UsersRequests.vue?vue&type=script&lang=js&"
export * from "./UsersRequests.vue?vue&type=script&lang=js&"
import style0 from "./UsersRequests.vue?vue&type=style&index=0&id=6bde5704&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bde5704",
  null
  
)

export default component.exports